import "intl";

import { shouldPolyfill as shouldPolyfillPluralRules } from "@formatjs/intl-pluralrules/should-polyfill";
import { shouldPolyfill as shouldPolyfillRelativeTimeFormat } from "@formatjs/intl-relativetimeformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillIntlDisplayNames } from "@formatjs/intl-displaynames/should-polyfill";
import { shouldPolyfill as shouldPolyfillGetCanonicalLocales } from "@formatjs/intl-getcanonicallocales/should-polyfill";
import { shouldPolyfill as shouldPolyfillIntlLocale } from "@formatjs/intl-locale/should-polyfill";
import { shouldPolyfill as shouldPolyfillNumberFormat } from "@formatjs/intl-numberformat/should-polyfill";

import { loadScriptOnce } from "../../../components/Utils/loadScriptOnce";

if (
  shouldPolyfillPluralRules() ||
  shouldPolyfillRelativeTimeFormat() ||
  shouldPolyfillIntlDisplayNames() ||
  shouldPolyfillGetCanonicalLocales() ||
  shouldPolyfillIntlLocale() ||
  shouldPolyfillNumberFormat()
) {
  const locale = document.documentElement.lang;
  loadScriptOnce(`/assets/config/polyfills/formatjs/${locale}.js`);
}
